import React, { useState } from 'react';
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@material-ui/core';
import Modal from 'components/ui/modal';


function CheckMeetingTypeModal({ setShowDoneModal }) {
    const [onClose, setOnClose] = useState(true)
    return (
        <>
            <Modal
                fullWidth
                open={onClose}
                title="Was this a Coaching Session?"
                maxWidth="sm"
                color='primary'
            >
               
                <Box>
                    <Box display="flex" alignItems="center" justifyContent="center">
                        <FormControl>
                        <FormLabel style={{marginTop:'-1em'}}> (Please do not mark a milestone meeting as completed if you are a college coach. This is something that only HCs are expected to do. In the same way, only College coaches are allowed to mark a coaching session as completed.)</FormLabel>
                            <RadioGroup style={{marginTop:'1em',gap:'5em'}} row>
                                <FormControlLabel onClick={() => { setOnClose(false); setShowDoneModal(true) }} value="yes" control={<Radio />} label="Yes" />
                                <FormControlLabel onClick={() => setOnClose(false)} value="no" control={<Radio />} label="No" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>
            </Modal>
        </>
    )
}

export default CheckMeetingTypeModal;
